import { cn } from '@/lib/utils';
import { Move3dIcon, Rotate3DIcon, type LucideIcon } from 'lucide-react';
import { TransformToolEnum } from '@modules/three/common/transformMesh/TransformToolEnum.ts';
import useThreeInteractionStore from '@modules/three/hooks/useThreeInteractionStore.ts';

interface TransformToolProps {
  className?: string;
}

const TOOLS: { value: TransformToolEnum; label: string; icon: LucideIcon }[] = [
  { value: TransformToolEnum.TRANSLATE, label: 'Move', icon: Move3dIcon },
  { value: TransformToolEnum.ROTATE, label: 'Rotate', icon: Rotate3DIcon },
];

export function TransformTool({ className }: TransformToolProps) {
  const { transformTool, setTransformTool } = useThreeInteractionStore();

  return (
    <div
      role="radiogroup"
      aria-label="Transform tool"
      className={cn(
        'flex items-center gap-1 rounded-lg border border-white/8 bg-content-dark/70 p-1',
        className,
      )}
    >
      {TOOLS.map(({ value, label, icon: Icon }) => {
        const active = transformTool === value;
        return (
          <button
            key={value}
            type="button"
            role="radio"
            aria-checked={active}
            aria-label={label}
            title={label}
            onClick={() => setTransformTool(value)}
            className={cn(
              'flex flex-1 items-center justify-center gap-1.5 rounded-md px-2 py-1.5 text-xs font-medium transition-colors',
              active
                ? 'bg-primary text-white shadow-sm shadow-primary/30'
                : 'text-white/55 hover:bg-white/5 hover:text-white/85',
            )}
          >
            <Icon className="size-3.5" />
            {label}
          </button>
        );
      })}
    </div>
  );
}
